import React, { useState } from "react";
import { X } from "lucide-react";

const AnnouncementBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-teal-500 to-teal-600 text-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3">
          <div className="flex-1 flex items-center justify-center px-2">
            {/* Mobile version with extra small text for single line */}
            <div className="text-center sm:hidden">
              <span className="font-medium text-xs mr-1" style={{fontSize: '10px'}}>
                🎉 We've raised $4M from 
              </span>
              <span className="font-bold text-xs" style={{fontSize: '10px'}}>
                SC Ventures, Zeenovy, and DRT.
              </span>
            </div>
            
            {/* Desktop version with full investor names */}
            <div className="text-center hidden sm:block">
              <span className="font-medium text-base mr-1">
                🎉 We've raised $4M from 
              </span>
              <span className="font-bold text-base">
                Sercy Ventures, Zeenovy, and DRT.
              </span>
            </div>
          </div>
          
          {/* Close button */}
          <button
            onClick={() => setIsVisible(false)}
            className="flex-shrink-0 ml-4 p-1 rounded-full text-teal-100 hover:text-white hover:bg-teal-400 transition-colors duration-200"
            aria-label="Dismiss announcement"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;